// extracted by mini-css-extract-plugin
export default {"tvIcon":"DeviceSetup_tvIcon__D4E2Z"};